import React from "react";

export const Privacy = () => {
  return (
    <div className="w-full px-8 py-10 bg-slate-50 text-[#14141f]">
      <div className="space-y-6">
        <h5 className="text-md font-semibold mt-4 mb-2">
          Polityka Prywatności WeExpert
        </h5>
        <p>Ostatnia aktualizacja: 9 września 2025 r.</p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          1) Kto jest Administratorem Twoich danych?
        </h5>
        <p>
          WEEXPERT SP. Z O.O. z siedzibą we Wrocławiu, ul. Marsz. Józefa
          Piłsudskiego 74/320, 50‑020 Wrocław, wpisana do rejestru
          przedsiębiorców prowadzonego przez Sąd Rejonowy w Bydgoszczy, XIII
          Wydział Gospodarczy KRS, KRS: 0000986528, NIP: 9671458021, REGON:
          52278693000000, kapitał zakładowy: 106 700 zł (dalej: „WeExpert” lub
          „Administrator”).
        </p>
        <p>
          Kontakt w sprawach ochrony danych: przez formularz/kontakt wskazany na
          stronie serwisu WeExpert lub na adres e‑mail podany na stronie. Jeśli
          powołamy Inspektora Ochrony Danych, przekażemy jego dane kontaktowe w
          tej polityce.
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          2) Zakres i kategorie przetwarzanych danych
        </h5>
        <p>
          Przetwarzamy dane tylko w takim zakresie, jaki jest potrzebny do
          korzystania z naszego serwisu i usług. Mogą to być:
        </p>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>
            <strong>Dane konta i profilowe</strong> – imię, nazwisko, adres
            e‑mail, numer telefonu, adres, NIP (jeśli dotyczy), dane
            rozliczeniowe, numer rachunku, rola/profil użytkownika; dane
            ujawniane przez Ciebie w profilu (o ile zdecydowałeś/aś się je
            upublicznić).
          </li>
          <li>
            <strong>Dane transakcyjne i komunikacja</strong> – informacje o
            zamówieniach/zleceniach, płatnościach, wiadomościach, komentarzach
            oraz rozliczeniach.
          </li>
          <li>
            <strong>Obsługa użytkownika</strong> – dane zawarte w
            zapytaniach/reklamacjach (np. imię, nazwisko, e‑mail, dane podatkowe
            jeśli wymagane przepisami).
          </li>
          <li>
            <strong>Dane z urządzenia i serwisu</strong> – adres IP,
            identyfikatory urządzeń/aplikacji, dane o przeglądarce/systemie,
            logi, cookies i podobne technologie (zgodnie z naszą polityką plików
            cookies).
          </li>
          <li>
            <strong>Logowanie przez zewnętrznych dostawców (np. Google)</strong>{" "}
            – jeśli wybierzesz tę opcję, otrzymamy m.in. imię i nazwisko,
            e‑mail, identyfikator konta i zdjęcie profilowe; połączenie możesz w
            każdej chwili odłączyć w ustawieniach.
          </li>
          <li>
            <strong>Ankiety i badania</strong> – dobrowolnie podane dane (np.
            wiek, profil działalności, opinie) wykorzystywane statystycznie i do
            dostosowywania usług.
          </li>
          <li>
            <strong>Weryfikacja tożsamości (KYC/AML)</strong> – tylko jeśli jest
            konieczna dla bezpieczeństwa transakcji lub wymagają tego przepisy
            (np. imię, nazwisko, data urodzenia, PESEL/dokument tożsamości –
            przetwarzane także przez dostawców KYC działających w naszym
            imieniu).
          </li>
        </ul>

        <h5 className="text-md font-semibold mt-4 mb-2">
          3) Cele i podstawy prawne przetwarzania
        </h5>
        <p>Przetwarzamy dane na podstawach z art. 6 RODO:</p>

        <h6 className="font-semibold mt-2">
          A. Realizacja umowy i świadczenie usług (art. 6 ust. 1 lit. b RODO)
        </h6>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>
            założenie i prowadzenie konta, realizacja zamówień/zleceń i
            płatności;
          </li>
          <li>umożliwienie komunikacji między użytkownikami i z nami;</li>
          <li>
            obsługa zapytań i reklamacji; zapewnienie bezpieczeństwa usług.
          </li>
        </ul>

        <h6 className="font-semibold mt-2">
          B. Obowiązki prawne (art. 6 ust. 1 lit. c RODO)
        </h6>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>rozliczenia podatkowe i rachunkowe;</li>
          <li>
            przeciwdziałanie nadużyciom, praniu pieniędzy i finansowaniu
            terroryzmu (jeśli dotyczy, w tym KYC);
          </li>
          <li>obsługa zgłoszeń sygnalistów w zakresie wymaganym prawem;</li>
          <li>wykazanie zgodności z RODO (rozliczalność).</li>
        </ul>

        <h6 className="font-semibold mt-2">
          C. Nasz uzasadniony interes (art. 6 ust. 1 lit. f RODO)
        </h6>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>analiza działania serwisu i ulepszanie usług;</li>
          <li>bezpieczeństwo IT, zapobieganie oszustwom i nadużyciom;</li>
          <li>
            komunikacja z użytkownikami (także archiwizacja dowodowa na potrzeby
            roszczeń);
          </li>
          <li>statystyka i analityka;</li>
          <li>
            dopasowany marketing własnych usług (w tym ograniczone
            profilowanie);
          </li>
          <li>
            weryfikacja zachowań automatycznych/botów (np. reCAPTCHA – jeśli
            używamy).
          </li>
        </ul>

        <h6 className="font-semibold mt-2">
          D. Zgoda (art. 6 ust. 1 lit. a RODO)
        </h6>
        <p>Tylko tam, gdzie jest potrzebna i zawsze dobrowolna:</p>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>cookies/technologie podobne niewymagające innej podstawy;</li>
          <li>ankiety i działania marketingowe wymagające zgody;</li>
          <li>
            przekazywanie danych partnerom w celu personalizacji ofert
            (wyłącznie gdy wyrazisz na to zgodę i możesz ją wycofać w każdej
            chwili).
          </li>
        </ul>

        <p>
          Nie podejmujemy decyzji wywołujących skutki prawne wyłącznie w oparciu
          o zautomatyzowane przetwarzanie (bez udziału człowieka).
        </p>
      </div>
      <div className="space-y-6">
        <h5 className="text-md font-semibold mt-4 mb-2">
          4) Odbiorcy danych i przekazywanie poza EOG
        </h5>
        <p>
          Twoje dane możemy powierzać zaufanym podmiotom przetwarzającym (na
          podstawie umów powierzenia), m.in. dostawcom hostingu i chmury,
          narzędzi IT/CRM, płatności, obsługi klienta, księgowości, audytu,
          marketingu, weryfikacji tożsamości (KYC), a także doradcom prawnym.
          Podmioty te działają wyłącznie zgodnie z naszymi instrukcjami i muszą
          zapewnić stosowne środki bezpieczeństwa.
        </p>
        <p>
          Jeśli w konkretnym przypadku zajdzie potrzeba przekazania danych poza
          Europejski Obszar Gospodarczy, zrobimy to wyłącznie przy zastosowaniu
          mechanizmów wymaganych przez prawo (np. decyzje stwierdzające
          odpowiedni poziom ochrony, standardowe klauzule umowne) i
          poinformujemy o tym w sposób dla Ciebie czytelny (np. w polityce
          cookies lub w trakcie zbierania zgody).
        </p>
        <p>
          Dane możemy też udostępniać uprawnionym organom publicznym –
          wyłącznie, gdy wymagają tego przepisy (np. sądy, organy ścigania,
          organy podatkowe).
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          5) Okres przechowywania
        </h5>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>
            okres posiadania aktywnego konta, a po jego usunięciu – przez czas
            niezbędny do rozliczeń i obrony przed roszczeniami;
          </li>
          <li>
            okresy wymagane prawem (np. dokumentacja księgowa – co do zasady 5
            lat);
          </li>
          <li>
            w przypadku danych przetwarzanych na podstawie zgody – do wycofania
            zgody lub realizacji celu, a następnie przez czas niezbędny do
            rozliczalności.
          </li>
        </ul>
        <p>
          Zawsze stosujemy zasadę minimalizacji – nie przechowujemy danych
          dłużej, niż to konieczne.
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">6) Twoje prawa</h5>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>dostępu do danych i uzyskania ich kopii;</li>
          <li>sprostowania (poprawienia) danych;</li>
          <li>
            usunięcia danych („prawo do bycia zapomnianym”) – jeśli zachodzą
            przesłanki z art. 17 RODO;
          </li>
          <li>ograniczenia przetwarzania;</li>
          <li>
            sprzeciwu wobec przetwarzania opartego na naszym uzasadnionym
            interesie, w tym wobec marketingu bezpośredniego (wraz z
            profilowaniem do tych celów);
          </li>
          <li>
            przenoszenia danych – gdy podstawą jest zgoda lub umowa, a
            przetwarzanie odbywa się w sposób zautomatyzowany;
          </li>
          <li>
            wycofania zgody – w dowolnym momencie (nie wpływa to na zgodność z
            prawem przetwarzania przed cofnięciem);
          </li>
          <li>
            skargi do Prezesa UODO (lub innego właściwego organu nadzorczego w
            UE).
          </li>
        </ul>

        <h5 className="text-md font-semibold mt-4 mb-2">
          7) Jak realizować prawa i jak się z nami skontaktować?
        </h5>
        <p>
          Najprościej – skorzystaj z danych kontaktowych wskazanych w serwisie
          WeExpert (formularz kontaktowy lub adres e‑mail). W zgłoszeniu wskaż,
          z którego prawa chcesz skorzystać. Odpowiemy bez zbędnej zwłoki, nie
          później niż w ciągu miesiąca (termin może zostać wydłużony zgodnie z
          art. 12 RODO – poinformujemy Cię wtedy o przyczynach).
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          8) Cookies i podobne technologie
        </h5>
        <p>
          Szczegółowe informacje znajdziesz w naszej{" "}
          <a href="/help-info" className="text-blue-600 underline">
            Polityce plików cookies
          </a>
          . W ramach ustawień przeglądarki i/lub naszego banera cookies możesz
          zarządzać zgodami. Niektóre cookies są niezbędne do działania serwisu
          i nie wymagają Twojej zgody.
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          9) Bezpieczeństwo danych
        </h5>
        <p>
          Stosujemy odpowiednie środki techniczne i organizacyjne zapewniające
          bezpieczeństwo danych (m.in. szyfrowanie, kontrola dostępu, testy
          bezpieczeństwa, zasada minimalizacji). Wymagamy tego samego od naszych
          dostawców i partnerów przetwarzających.
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          10) Zmiany niniejszej polityki
        </h5>
        <p>
          Polityka może być aktualizowana, gdy zmieniają się przepisy lub nasze
          procesy. Zawsze podajemy datę ostatniej aktualizacji, a w przypadku
          istotnych zmian – przekażemy czytelną informację (np. komunikat w
          serwisie).
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          Słowniczek (pomocniczo)
        </h5>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>
            <strong>RODO</strong> – Rozporządzenie Parlamentu Europejskiego i
            Rady (UE) 2016/679 z 27.04.2016 r.
          </li>
          <li>
            <strong>Administrator</strong> – podmiot decydujący o celach i
            sposobach przetwarzania danych (tu: WeExpert).
          </li>
          <li>
            <strong>Podmiot przetwarzający</strong> – podmiot przetwarzający
            dane w imieniu Administratora na podstawie umowy (np. dostawca
            hostingu).
          </li>
          <li>
            <strong>Dane osobowe</strong> – informacje pozwalające
            zidentyfikować osobę fizyczną (np. imię i nazwisko, e‑mail, adres
            IP).
          </li>
        </ul>

        <p>
          Ta strona może być chroniona przez mechanizmy bezpieczeństwa takie jak
          reCAPTCHA. Warunki takiej usługi oraz jej polityka prywatności
          dostępne są u odpowiedniego dostawcy (np. Google), jeżeli aktualnie z
          niej korzystamy.
        </p>
      </div>
    </div>
  );
};
